import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = "JesusAmigoWebsite"

  @ViewChild('somos')
  somos: ElementRef;

  @ViewChild('historia')
  historia: ElementRef;

  @ViewChild('trabajo')
  trabajo: ElementRef;

  @ViewChild('ayuda')
  ayuda: ElementRef;

  @ViewChild('contacto')
  contacto: ElementRef;

  scroll(tag: string) {

    switch (tag) {
      case "somos":
        this.somos.nativeElement.scrollIntoView({ behavior: 'smooth' })
        break;
      case "historia":
        this.historia.nativeElement.scrollIntoView({ behavior: 'smooth' })
        break;
      case "trabajo":
        this.trabajo.nativeElement.scrollIntoView({ behavior: 'smooth' })
        break;
      case "ayuda":
        this.ayuda.nativeElement.scrollIntoView({ behavior: 'smooth' })
        break;
      case "contacto":
        this.contacto.nativeElement.scrollIntoView({ behavior: 'smooth' })
        break;
      default:
        break;
    }

  }
}
